import { useAuth } from "@assetwatch/auth";
import { Button, Container, Stack, Text, Title } from "@assetwatch/ui";
import { clearRetainedListState } from "../lib/retainedListState";

/**
 * The single not-authorized screen for Work. It renders outside the app shell,
 * so a user without access never sees the sidebar or header.
 */
export function WorkAccessDenied() {
  const { signOut } = useAuth();

  return (
    <Container size="sm">
      <Stack gap={16}>
        <Title as="h1" size="lg">
          You are not authorized to access Work
        </Title>
        <Text tone="subtle">Contact your administrator to request access.</Text>
        <Button
          icon="logout-exit"
          type="button"
          variant="outline"
          onClick={() => {
            clearRetainedListState();
            void signOut();
          }}
        >
          Sign out
        </Button>
      </Stack>
    </Container>
  );
}
